import KubernatesLogo from './images/kubernates_logo.svg';
import KubernatesLogoWhite from './images/kubernates_logo_white.svg';
import Image404 from './images/404.svg';
import AMD from './images/cpus/amd.svg';
import INTEL from './images/cpus/intel.svg';

import DE from './images/flags/germany.svg';
import US from './images/flags/united-states.svg';
import UK from './images/flags/united-kingdom.svg';
import KR from './images/flags/south-korea.svg';
import ES from './images/flags/spain.svg';
import FR from './images/flags/france.svg';

import LOGO from './images/generic-logo.svg';
import EMPTY from './images/empty.svg';

export default {
  LOGO,
  KubernatesLogo,
  KubernatesLogoWhite,
  Image404,
  AMD,
  INTEL,
  EMPTY,

  // Countries
  DE,
  US,
  UK,
  KR,
  ES,
  FR,
};
